<template>
	<div id="becproperty-editor"
		 class="app-home ui-styles"
		 :class="theme">

		<template class="view_container">

			<div class="loading_view" v-if="master_loading">
				<div class="view_spinner_container">
					<span style="color: rgb(0, 79, 146); margin: 0 auto;">
					<icon name="spinner" scale="4"
						  color="rgb(0, 79, 146)" spin></icon></span><br>
					<span>{{ $t('Loading')}}...</span>
				</div>
			</div>

			<div class="master_view">
				<side-nav-bar :filesOpen="filesOpen" :fileOpen="fileOpen" :reportOpen="reportOpen"></side-nav-bar>
				<div class="app-container">
					<bar>
					</bar>
					<h1><span v-if="currentLocale === 'ca'">{{ becproperty.name_ca }}</span><span
							v-else-if="currentLocale === 'en'">{{ becproperty.name_en }}</span><span
							v-else>{{ becproperty.name_es }}</span><span v-if="becproperty.dirty">*</span></h1>
					<message
							v-if="becproperty.dirty"
							:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
							border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
					</message>
					<div class="datedata">
						<p class="small">{{ $t('Created') }}: {{ millis_to_time(becproperty.date_created)
							}}</p>
						<p class="small">{{ $t('Last_modified')
							}}: {{ millis_to_time(becproperty.date_modified) }}</p>
					</div>

					<vue-tabs>
						<v-tab :title="data_text">
							<div class="tab_content">
								<form class="bt-form">
									<div class="section-container">
										<h3>{{ $t('Property_type') }} </h3>

										<div class="field-container">
											<div class="field__group">
												<label class="field__group__label">{{ $t('Name_ca') }}</label>
												<input class="field__group__input"
													   type="text"
													   spellcheck="false"
													   v-model="becproperty.name_ca"
													   @input="set_becproperty_name_ca">
											</div>
										</div>
										<div class="field-container">
											<div class="field__group">
												<label class="field__group__label">{{ $t('Name_en') }}</label>
												<input class="field__group__input"
													   type="text"
													   spellcheck="false"
													   v-model="becproperty.name_en"
													   @input="set_becproperty_name_en">
											</div>
										</div>
										<div class="field-container">
											<div class="field__group">
												<label class="field__group__label">{{ $t('Name_es') }}</label>
												<input class="field__group__input"
													   type="text"
													   spellcheck="false"
													   v-model="becproperty.name_es"
													   @input="set_becproperty_name_es">
											</div>
										</div>


									</div>
									<div class="section-container">
										<div>
											<form class="bt-form">
												<div class="form-section">
													<h3>Números B.E.C.</h3>
													<div>
														<div @click.prevent="onCreateNewBecPrice"
															 style="width: fit-content; margin-left: auto">
															<icon-button icon="plus-circle"
																		 :text="new_becprice_button_text"
																		 icon_color="black"
																		 text_color="black"
																		 border_color="lightgray"></icon-button>
														</div>
													</div>
													<div v-if="_.size(becproperty_becprices) > 0">
														<div class="grid-row" layout="row top-stretch">
															<div class="grid-cell" layout="row">
																<input type="text" :placeholder="filter_placeholder"
																	   self="size-x1"
																	   v-model="becprices_table.filter"
																	   data-intro="You can filter the data in a datatable by typing in any of the filter fields"
																	   data-step="9" data-position="top">
															</div>
														</div>
														<div class="grid-row" layout="row top-stretch">
															<div class="grid-cell">
																<paginator
																		:source="this.object_to_array(becproperty_becprices)"
																		:page-size="20"
																		:filter="becprices_table.filter"
																		data-intro="Use the paginator to page data for easier viewing"
																		data-step="10"
																		data-position="top">
																	<template scope="page">
																		<datatable id="data-table-becprices"
																				   :source="page.data"
																				   :filterable="false"
																				   :striped="becprices_table.striped"
																				   :editable="becprices_table.editable"
																				   :line-numbers="becprices_table.lineNumbers">
																			<datatable-column
																					v-for="column in becprices_table.columns"
																					:id="column.id"
																					:label="column.label"
																					:width="column.width"
																					:sortable="column.sortable"
																					:groupable="column.groupable"
																					:formatter="column.formatter">
																			</datatable-column>
																			<datatable-column id="actions-becprices"
																							  :label="actions_text"
																							  :sortable="false"
																							  :groupable="false"></datatable-column>
																			<template slot="actions-becprices"
																					  scope="cell">
																				<table class="actions-table">
																					<tr>
																						<td>
																							<a @click="editBecPrice(cell.row)"
																							   style="cursor: pointer;"
																							   :title="edit_text">
																								<icon name="pencil"
																									  scale="1"
																									  color="gray"></icon>
																							</a></td>
																						<td>
																							<a @click="duplicateBecPrice(cell.row)"
																							   style="cursor: pointer;"
																							   :title="duplicate_text">
																								<icon name="files-o"
																									  scale="1"
																									  color="gray"></icon>
																							</a></td>
																						<td>
																							<a @click="deleteBecPrice(cell.row)"
																							   style="cursor: pointer;"
																							   :title="delete_text">
																								<icon name="trash-o"
																									  scale="1"
																									  color="gray"></icon>
																							</a></td>
																					</tr>
																				</table>


																			</template>
																		</datatable>
																	</template>
																</paginator>
															</div>
														</div>
													</div>

												</div>

											</form>
										</div>
									</div>

								</form>
							</div>
						</v-tab>
						<v-tab :title="metadata_text">
							<div class="tab_content">
								<form class="bt-form">

								</form>
							</div>
						</v-tab>
					</vue-tabs>

					<div>
						<div @click.prevent="onGoUp" style="width: fit-content; margin-left: auto">
							<icon-button icon="chevron-left" :text="goup_button_text"
										 icon_color="black"
										 text_color="black" border_color="lightgray"></icon-button>
						</div>
					</div>
					<div>
						<div @click.prevent="onSaveCurrentBecProperty({go_up: false})"
							 style="width: fit-content; margin-left: auto">
							<icon-button icon="floppy-o" :text="save_button_text" icon_color="white"
										 text_color="white" border_color="#006bc5"
										 background_color="#0087F8"></icon-button>
						</div>
					</div>
					<div>
						<div @click.prevent="onSaveCurrentBecProperty({go_up: true})"
							 style="width: fit-content; margin-left: auto">
							<icon-button icon="floppy-o" :text="save_and_go_up_button_text" icon_color="white"
										 text_color="white" border_color="#006bc5"
										 background_color="#0087F8"></icon-button>
						</div>
					</div>
					<message
							v-if="becproperty.dirty"
							:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
							border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
					</message>
					<!--
					<bar>
					</bar>
-->
				</div>
			</div>

		</template>
	</div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import Vue from 'vue'
    import _ from 'lodash'
    import moment from 'moment'
    import { dateMixin, localStorageMixin, objectsMixin } from '../../../mixins'
    import Spinner from '../../../components/Spinner.vue'
    import Search from '../../../components/ContactsSearch/Index.vue'
    import Editor from '../../../components/Editor/Index.vue'
    import Bar from '../../../components/Bar/Index.vue'
    import IconButton from '../../../components/IconButton/Index.vue'
    import SideNavBar from '../../../components/SideNavBar/Index.vue'

    import router from '../../../router/index.js'

    import Message from '../../../components/Message.vue'

    import petitioner_typeOptions from '../../../options/petitioner_types'

    import Datatable from '../../../components/Datatable/datatable.vue'
    import DatatableColumn from '../../../components/Datatable/datatable-column.vue'
    import aggregators from '../../../aggregators/aggregators.js'
    import formatters from '../../../formatters/formatters.js'
    import Checkbox from '../../../components/Toggles/checkbox.vue'
    import Paginator from '../../../components/Paginator/paginator.vue'

    export default {
        name: 'becproperty-editor',

        mixins: [
            dateMixin,
            localStorageMixin,
            objectsMixin
        ],

        data: () => ({
            loading: true,
            master_loading: true,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            error: null,
            success_message: null,
            metadata_text: Vue.i18n.translate('Metadata'),
            data_text: Vue.i18n.translate('Data'),
            report_title_error_text: Vue.i18n.translate('Report_title_missing_error_text'),
            new_real_estate_button_text: Vue.i18n.translate('Add_real_estate'),
            new_becprice_button_text: Vue.i18n.translate('Add_bec_number'),
            cancel_button_text: Vue.i18n.translate('Cancel'),
            goup_button_text: Vue.i18n.translate('Go_up') + ' ' + Vue.i18n.translate('without_saving'),
            pdf_button_text: Vue.i18n.translate('Print_report_in_PDF'),
            save_button_text: Vue.i18n.translate('Save'),
            save_and_go_up_button_text: Vue.i18n.translate('Save') + ' ' + Vue.i18n.translate('and') + ' ' + Vue.i18n.translate('go_up'),
            page_dirty_text: Vue.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: Vue.i18n.translate('Actions'),
            filter_placeholder: Vue.i18n.translate('Type_here_to_filter_paginated_data'),
            becprice_appraisaldateValue: null,
            duplicate_text: Vue.i18n.translate('Duplicate'),
            edit_text: Vue.i18n.translate('Edit'),
            delete_text: Vue.i18n.translate('Delete'),
            discard_text: Vue.i18n.translate('Discard'),
            openlink_text: Vue.i18n.translate('Open_link_in_new_tab'),
            petitionerValue: null,
            petitioner_typeValue: null,
            petitioner_typeOptions,
            becprices_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'number',
                        label: Vue.i18n.translate('Number'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'year',
                        label: Vue.i18n.translate('Year'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'quarter',
                        label: Vue.i18n.translate('Quarter'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'date_modified',
                        label: Vue.i18n.translate('Last_modified'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return moment(value).format('DD/MM/YYYY HH:mm:ss')
                        }
                    }
                ],
                selected: []
            },
        }),

        created () {
            this.FETCH_BECPROPERTY_BECPRICES({
                path: 'becproperty_becprices' + '/' + this.$route.query.id,
                becproperty_id: this.$route.query.id
            })
                .then(() => {
                    this.master_loading = false
                })
        },

        components: {
            Bar,
            Message,
            IconButton,
            Spinner,
            SideNavBar,
            Checkbox,
            Datatable,
            DatatableColumn,
            Paginator
        },

        computed: {
            ...mapGetters([
                'theme',
                'tags_display',
                'currentLocale',
                'becproperty',
                'becproperty_becprices',
                'becprice'
            ])
        },

        methods: {
            ...mapActions(
                [
                    'CHECK_BECPROPERTY_BECPRICE_APPRAISALS',
                    'CREATE_NEW_BECPRICE',
                    'DELETE_BECPRICE',
                    'FETCH_BECPROPERTY_BECPRICES',
                    'RESET_BECPRICE',
                    'SET_BECPRICE',
                    'GET_BECPRICE',
                    'UPDATE_BECPROPERTY',
                    'UPDATE_BECPRICE',

                    'SET_BECPROPERTY_NAME_CA',
                    'SET_BECPROPERTY_NAME_EN',
                    'SET_BECPROPERTY_NAME_ES',
                ]),
            set_becproperty_name_ca: _.debounce(function (e) {
                this.SET_BECPROPERTY_NAME_CA(e.target.value)
            }, 1000),
            set_becproperty_name_en: _.debounce(function (e) {
                this.SET_BECPROPERTY_NAME_EN(e.target.value)
            }, 1000),
            set_becproperty_name_es: _.debounce(function (e) {
                this.SET_BECPROPERTY_NAME_ES(e.target.value)
            }, 1000),

            onCreateNewBecPrice: function () {
                this.master_loading = true

                this.RESET_BECPRICE().then((res) => {
                    this.CREATE_NEW_BECPRICE({
                        becproperty_id: this.becproperty.id,
                        path: 'becproperty_becprices' + '/' + this.becproperty.id + '/',
                    }).then((res) => {
                        this.FETCH_BECPROPERTY_BECPRICES({
                            path: 'becproperty_becprices' + '/' + this.$route.query.id,
                            becproperty_id: this.$route.query.id
                        })
                            .then(() => {
                                this.master_loading = false
                            })
                        // this.master_loading = false
                        // this.$router.push({name: 'becprice-editor', query: {id: res.key}})

                    })
                })
            },
            editBecPrice: function (entity) {
                this.SET_BECPRICE({path: 'becproperty_becprices' + '/' + this.becproperty.id + '/' + entity.id + '/'}).then((res) => {
                    this.$router.push({name: 'becprice-editor', query: {id: entity.id}})

                })
            },
            deleteBecPrice: function (entity) {

                const result = window.confirm(Vue.i18n.translate('You_are_about_to_delete ') + entity.number + '. ' + Vue.i18n.translate('Continue_q'))

                if (result) {
                    this.master_loading = true
                    this.DELETE_BECPRICE({
                        path: 'becproperty_becprices' + '/' + this.becproperty.id + '/' +  entity.id,
                        key: entity.id
                    }).then((res) => {
                        //

                        this.FETCH_BECPROPERTY_BECPRICES({
                            path: 'becproperty_becprices' + '/' + this.$route.query.id,
                            becproperty_id: this.$route.query.id
                        })
                            .then(() => {
                                this.master_loading = false
                            })
                    })

                }

            },
			duplicateBecPrice: function (entity){
                this.master_loading = true

                this.RESET_BECPRICE().then((res) => {
                    this.CREATE_NEW_BECPRICE({
                        becproperty_id: this.becproperty.id,
                        path: 'becproperty_becprices' + '/' + this.becproperty.id + '/',
                    }).then((res) => {

                        const new_object_id = res.key

                        this.GET_BECPRICE({ path: 'becproperty_becprices' + '/' + this.becproperty.id + '/' +  entity.id }).then((res) => {



                            let new_object = res
                            new_object.id = new_object_id


                            this.UPDATE_BECPRICE({
                                object: new_object,
                                path: 'becproperty_becprices' + '/' + this.becproperty.id + '/',
                                key: new_object_id
                            }).then((res) => {

                                this.FETCH_BECPROPERTY_BECPRICES({
                                    path: 'becproperty_becprices' + '/' + this.$route.query.id,
                                    becproperty_id: this.$route.query.id
                                })
                                    .then(() => {
                                        this.master_loading = false
                                    })

                            })

                        })


                    })
                })
			},
            onSaveCurrentBecProperty: function (data) {
                this.UPDATE_BECPROPERTY({
                    object: this.becproperty,
                    path: this.becproperty.path,
                    parent_path: this.becproperty.parent_path,
                    key: this.becproperty.id
                }).then((res) => {
                    // router.go(-1)
                    if (data.go_up) {
                        this.onGoUp()
                    }
                })
            },
            onGoBack: function () {
                router.go(-1)
            },
            onGoUp: function () {
                this.$router.push({name: 'becproperties-index'})
            }
        },
        head: {
            title: {
                inner: 'Edit becproperty'
            }
        }

    }
</script>


// WEBPACK FOOTER //
// BecPropertyEditor.vue?59127600